module.exports = __webpack_public_path__ + "static/logo_primary-a5f03e752689545f571544bbc9e17db7.png";